import { Component, OnInit, HostBinding } from '@angular/core';
import { MestradoService } from '../../service/mestrado.service';
import { DetalheCursoComponent } from '../detalhe-curso.component';
import { DocumentosService } from 'app/shared/documentos/documentos.service';
import { Documento, AgrupadorDocumentos } from 'models/documento';
import { routerTransition } from 'app/shared/animations/router-transition.animation';


@Component({
  selector: 'cm-processo-seletivo',
  templateUrl: './processo-seletivo.component.html',
  styleUrls: ['./processo-seletivo.component.scss'],
  animations: [routerTransition],
})
export class ProcessoSeletivoComponent implements OnInit {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';
  
  listaProcessoSeletivo: Object[] = [];
  cronogramaCarregando = true;
  editais: Documento[] = [];
  editaisLoading = false;
  inscricaoAberta: boolean;

  constructor(
    private processoSeletivo: MestradoService,
    private idCurso: DetalheCursoComponent,
    private documentosService: DocumentosService
    ) { }

  ngOnInit() {
    
    const idCurso = this.idCurso.cursoIdentificador;
   
    this.processoSeletivo.listCursoMestradoId(idCurso)
        .subscribe(processo => {
            this.listaProcessoSeletivo = processo.cursosposgraduacao;
            this.inscricaoAberta = processo.cursosposgraduacao[0].inscricaoAberta;
            this.cronogramaCarregando = false;
        });
    
    this.getEditais(idCurso);
  }

  async getEditais(idCurso: string){
    
    let slug = await this.processoSeletivo.listCursoName(idCurso);
    const agrupadorDocs: AgrupadorDocumentos[] = await this.documentosService.queryEditaisPosGraduacao(slug);

    if (agrupadorDocs && agrupadorDocs.length > 0) {
      this.editaisLoading = true;
      this.editais = agrupadorDocs[0].documentos;
    } else {
      this.editaisLoading = false;
      console.warn('Nenhnum edital para o curso');
    }
    this.editaisLoading = false;
  }
  }

